module.exports = __webpack_public_path__ + "static/media/4.ce874694.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instructorsPhoto/4.jpg
// module id = 245
// module chunks = 1